import React from 'react';
import classnames from 'classnames';
import Button, { type ButtonVariant } from '../Button';
import s from './PageHeader.module.scss';
import { Description } from '../PageDetails';
import RichText from '../RichText';

interface ButtonDetails {
  onClick?: () => void;
  label?: string;
  link?: string;
}

interface PageHeaderProps {
  children?: React.ReactNode;
  className?: string;
  description?: Description | string;
  variant?: ButtonVariant;
  title?: string;
  buttonDetails?: ButtonDetails;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  variant = 'primary',
  description,
  className,
  buttonDetails,
  children,
}) => (
  <div className={s.container} data-aos="fade-up" data-testid="pageHeader">
    <div className={classnames(s.root, className)}>
      {!children ? (
        <>
          <h2 data-testid="pageHeaderTitle">{title}</h2>
          <p className={s.description} data-testid="pageHeaderDescription">
            {typeof description === 'string' ? (
              description
            ) : description && 'root' in description && description.root ? (
              <RichText data={description} />
            ) : null}
          </p>

          {buttonDetails?.label && (
            <div
              className={s.button}
              data-testid="mock-button"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              <Button variant={variant} onClick={buttonDetails?.onClick}>{buttonDetails.label}</Button>
            </div>
          )}
        </>
      ) : (
        children
      )}
    </div>
  </div>
);

export default PageHeader;
